import { TABLE_ONLY_ALLOWED_VALUE_TYPES } from '../../../DataInput/DataInputMenu/helpers/data-input-menu.const';

export default {
	computed: {
		dataInputMenuValueTypes() {
			return TABLE_ONLY_ALLOWED_VALUE_TYPES;
		},
	},
};
